import { createAction } from '@reduxjs/toolkit';
import { TemplateObjectType } from '../api';

interface BaseActionPayload {
  handleFailure?(): void;
  handleAlways?(): void;
}

export interface SetConditionalVariablesActionPayload
  extends BaseActionPayload {
  variableId: number;
  formValues: any;
  templateType?: TemplateObjectType;
  templateId?: number;
}
export const setConditionalVariablesAction =
  createAction<SetConditionalVariablesActionPayload>(
    '@@TEMPLATES/PROJECT/conditionalVariables',
  );
